import { render, staticRenderFns } from "./classMsg.vue?vue&type=template&id=b3713334&scoped=true"
import script from "./classMsg.vue?vue&type=script&lang=js"
export * from "./classMsg.vue?vue&type=script&lang=js"
import style0 from "./classMsg.vue?vue&type=style&index=0&id=b3713334&prod&lang=scss"
import style1 from "./classMsg.vue?vue&type=style&index=1&id=b3713334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3713334",
  null
  
)

export default component.exports